import http from './http'

// 首页
export function postIndexAPI(params){
    return http.post('/index.php/api/index/index',params)
}

//服务品牌
export function postClientsAPI(params){
    return http.post('/index.php/api/deal/clients',params)
}

//公司介绍
export function postIntroduceAPI(params){
    return http.post('/index.php/api/deal/introduce',params)
}

// 服务案例
export function postCasesAPI(params){
    return http.post('/index.php/api/deal/cases',params)
}

//服务案例-精准投放
export function postfwtfAPI(params){
    return http.post('/index.php/api/deal/fwtf',params)
}

//服务案例-精准投放
export function postfwjsAPI(params){
    return http.post('/index.php/api/deal/fwjs',params)
}

//服务案例-内容营销
export function postfwnrAPI(params){
    return http.post('/index.php/api/deal/fwyx',params)
}

//服务内容
export function postcontAPI(params){
    return http.post('/index.php/api/deal/service',params)
}


//荣誉案例
export function posthornorAPI(params){
    return http.post('/index.php/api/deal/hornor',params)
}

//企业招聘
export function postrecruitAPI(params){
    return http.post('/index.php/api/deal/recruit',params)
}

//企业招聘
export function postcultureAPI(params){
    return http.post('/index.php/api/deal/culture',params)
}


export function postteamAPI(params){
    return http.post('/index.php/api/deal/team',params)
}

// 公司历程
export function postcompanyAPI(params){
    return http.post('/index.php/api/deal/company',params)
}

// 联系我们
export function postcontactAPI(params){
    return http.post('/index.php/api/deal/contact',params)
}

//其他配置信息的接口
export function postconfigAPI(params){
    return http.post('/index.php/api/index/cofings',params)
}

//招聘城市信心
export function postzpwzAPI(params){
    return http.post('/index.php/api/deal/zpwz',params)
}



//服务内容


//http://dx17.zbj99.cn/index.php/api/deal/fwjs


// export function getUserInfoAPI(params){
//     return http.get('/api/authorize/login',params)
// }



//////////////////
// WEBPACK FOOTER
// ./api/api.js
// module id = null
// module chunks = 